import { createFileRoute } from '@tanstack/react-router';

import {
  parseListRouteSearch,
  type ListRouteSearch,
} from '../../../hooks/use-list-table-helpers/index.js';
import { WorkOrderListPage } from '../../../modules/manufacturing/work-order-list-page.js';

export const Route = createFileRoute('/manufacturing/work-orders/')({
  validateSearch: (search: Record<string, unknown>): ListRouteSearch =>
    parseListRouteSearch(search),
  component: WorkOrderListPage,
});
